<script setup lang="ts">
import { computed, onMounted, ref } from 'vue';
import CardsContainer from '@/components/CardDysplay/CardsContainer.vue';
import CardsCarousel from '@/components/CardDysplay/CardsCarousel.vue';
import { useServicePlansStore } from '@/store/servicePlansStore';
import { planType } from '@/types/cardTypes';
import { useRouter } from 'vue-router';
import Card from '../CardDysplay/Card.vue';

interface CompProps {
  solutionId: number;
}

const router = useRouter();

const storePlans = useServicePlansStore();
const planoAvulso = ref<planType>({
  id: 4,
  name: 'Avulsa',
  price: 49.9,
  periodicity: 8,
  toSolutionId: 1,
  solutions: [
    {
      id: 2,
      name: 'Gestor Service',
      image: 'https://i.ibb.co/KLXjGzC/1.png',
      serviceLink: 'https://gestor.advservice.com.br/',
      createdAt: '2023-08-28T21:27:46.291Z',
      updatedAt: '2023-09-11T20:06:51.308Z',

      resources: [
        {
          id: 4,
          name: 'Acessoria e administração',
          description:
            "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book",
          solutionId: 2,
          createdAt: '2023-08-28T21:27:52.306Z',
          updatedAt: '2023-09-04T19:07:31.496Z',
          deletedAt: null,
        },
      ],
    },
  ],
  products: [
    {
      id: 3,
      name: 'Contrato de trabalho',
      createdAt: '2023-08-28T21:27:47.025Z',
      updatedAt: '2023-08-28T21:27:47.025Z',
    },
  ],
});

// eslint-disable-next-line no-undef, @typescript-eslint/no-unused-vars
const props = withDefaults(defineProps<CompProps>(), {
  solutionId: 1,
});

function goToSignUp(sPlan: planType): void {
  storePlans.setSelected(sPlan);
  window.scrollTo(0, 0);
  router.push('/planos/cadastro');
}

const unfPlan = ref<planType[]>([]);

const filteredPlans = computed(() => {
  return unfPlan.value
    ?.filter((x) => {
      return x.toSolutionId === null;
    })
    .sort(function (a, b) {
      return parseFloat(a?.id?.toString()) - parseFloat(b?.id?.toString());
    });
});

// eslint-disable-next-line no-undef
onMounted(async () => {
  unfPlan.value = await storePlans.getPlans();
  planoAvulso.value = storePlans.plans.find((item) => item.toSolutionId === props.solutionId) as planType;
});
</script>

<template>
  <CardsContainer ContainerTitle="Formas de Contratação">
    
    <div class="flex gap-24 flex-col lg:flex-row justify-center items-center lg:items-start px-6 lg:px-0">
      <!-- <Card
        :key="planoAvulso?.id"
        :id="planoAvulso?.id"
        :periodicity="planoAvulso?.periodicity"
        :cardTitle="planoAvulso?.name"
        :price="planoAvulso?.price"
        :solutions="planoAvulso?.solutions"
        @go-to-sign-up="goToSignUp(planoAvulso)"
      />
      <div class="w-full border-t lg:w-0 lg:border-r lg:border-t-0 lg:h-[50rem] border-white lg:-translate-y-8" /> -->
      <CardsCarousel :plans="filteredPlans" is-comparsion class="lg:max-w-xs comparison" />
    </div>
  </CardsContainer>
</template>

<style lang="css">
.comparison > .carousel__prev {
  left: 44% !important;
}

.comparison > .carousel__next {
  right: 44% !important;
}

@media screen and (min-width: 1024px) {
  .comparison > .carousel__prev {
    left: -15% !important;
  }
  .comparison > .carousel__next {
    right: -15% !important;
  }
}
</style>
